module.exports = "/_next/static/images/favicon-7dbebdc25cd083286e777238d2431e44.ico";